


 
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import "./About.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { IMG_URL, END_URL } from '../../config';
import { Helmet } from 'react-helmet';
 
function About() {
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [BannerImage, setBannerImage] = useState(null);

  const [seo, setSeo] = useState({});
  
  useEffect(() => {
    const fetchAbout = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${END_URL}/about`);
        if (Array.isArray(response.data.data) && response.data.data.length > 0) {
          setAbout(response.data.data[0]);
        } else {
          setError('No about data found.');
        }
        if (response.data.seo) {
          setSeo(response.data.seo);
        }
        if (response.data.about_image && response.data.about_image.image) {
          setBannerImage(response.data.about_image.image);
        }
      } catch (err) {
        console.error('Error fetching about data:', err);
        setError('Failed to fetch about data.');
      } finally {
        setLoading(false);
      }
    };
 
    fetchAbout();
  }, []);
 
  const getImageUrl = (path) => (path ? `${IMG_URL}/d0/${path}` : '');
 
  if (loading) return <div>Loading...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!about) return null;
 
  return (
    <>
          <Helmet>
      
              <title>{seo?.meta_title || 'PersonalityTest - Discover Your True Archetype | Personality Peek'}</title>

              <meta name="description" content={seo?.meta_description || 'Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey.'} />

              <meta name="keywords" content={seo?.meta_keywords || 'personality assessment test , personality test'} />
              
              {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
              {seo?.og_description && <meta property="og:description" content={seo.og_description} />}
              {seo?.og_image && <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />}
              {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
              {seo?.og_type && <meta property="og:type" content={seo.og_type} />}

              {seo?.twitter_title && <meta name="twitter:title" content={seo.twitter_title} />}
              {seo?.twitter_description && <meta name="twitter:description" content={seo.twitter_description} />}
              {seo?.twitter_image && <meta name="twitter:image" content={`${IMG_URL}/d0/${seo.twitter_image}`} />}
              {seo?.twitter_card && <meta name="twitter:card" content={seo.twitter_card} />}

              {seo?.og_url && <link rel="canonical" href={seo.og_url} />}

              {!seo?.og_title && <meta property="og:title" content="PersonalityTest - Discover Your True Archetype | Personality Peek" />}
              {!seo?.og_description && <meta property="og:description" content="Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey." />}
              {!seo?.og_type && <meta property="og:type" content="website" />}
              {!seo?.twitter_card && <meta name="twitter:card" content="summary_large_image" />}

       </Helmet>

        <div className="about-main">
          {/* Banner and Title */}
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div>
                  {BannerImage && (
                    <img src={BannerImage} alt="Self discovery and inner connection concept by Personality Peek with abstract personalities emerging in clouds" />
                  )}
                  <div>
                    <div dangerouslySetInnerHTML={{ __html: about.title }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          {/* Section 1 Content */}
          <div className="about-first">
            <div className="container">
              <div className="row">
                <div
                  className="col-12 col-sm-12 col-md-12 about-box1"
                  dangerouslySetInnerHTML={{ __html: about.content1 }}
                />
    
                <div className="col-12 col-sm-12 col-md-12 about-box2">
                  <div className="row">
                    <div
                      className="col-md-8"
                    
                    >
    
                      <div  dangerouslySetInnerHTML={{ __html: about.content2 }}></div>
                      
                        {about.buttontext && (
                          <a href="/test/free-starter-quiz" className="about-btn">
                            <div dangerouslySetInnerHTML={{ __html: about.buttontext }}></div>
                            <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span>
                          </a>
                        )}
                  
                      {/* <div className="col-md-8 mt-3">
                      {about.buttontext && (
                        <a href="#" className="about-btn">
                          <div dangerouslySetInnerHTML={{ __html: about.buttontext }}></div>
                          <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span>
                        </a>
                      )}
                    </div> */}
                    </div>
                    <div className="col-md-4">
                      <div>
                        {about.image && (
                          <img
                            src={getImageUrl(about.image)}
                            alt="Self discovery illustration by Personality Peek showing calm introspection and personality awareness"
    
                          />
    
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          {/* Section 2 Content */}
          <div className="about-color-div">
            <div className="container">
              <div className="row">
                <div
                  className="col-12 col-sm-12 col-md-12 about-box3"
                  dangerouslySetInnerHTML={{ __html: about.content3 }}
                />
              </div>
              
              <div className="row mt-4">
                <div
                  className="col-12"
                  dangerouslySetInnerHTML={{ __html: about.content5 }}
                />
              </div>
            </div>
          </div>
    
          {/* Mission & Image */}
          <div className="about-div-mission">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-8 div-mission-text">
                  <div
                    dangerouslySetInnerHTML={{ __html: about.content4 }}
                  />
                </div>
                <div className="col-12 col-sm-12 col-md-4 div-mission-img">
                  <div>
                    {about.image2 && (
                      <img
                        src={getImageUrl(about.image2)}
                        alt="Self discovery journey with Personality Peek – playful personality exploration in a dreamy, relaxing setting"
    
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
    
          {/* Final Section */}
          <div className="about-div-last">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 about-box5">
    
                  <div className="row">
                    <div className="col-md-12">
                    <div dangerouslySetInnerHTML={{ __html: about.content5 }} />
    
                    {/* <a className="about-btn" >Begin the free starter quiz<span> <FontAwesomeIcon className="icc" icon={faArrowRight} /></span> </a> */}
    
                    {about.buttontext2 && (
                      <a href="/test/free-starter-quiz" className="about-btn"  >
                        <div dangerouslySetInnerHTML={{ __html: about.buttontext2 }}></div>
                        <span><FontAwesomeIcon className="icc" icon={faArrowRight} /></span>
                      </a>
                    )}
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div >
    </>
  );
}
 
export default About;
 
 